<template>
  <div class="referral">
    <div class="subheading grey--text mt-6 ml-1"><h5>Send SMS</h5></div>
    <div class="mt-4 ml-1">
      <v-tabs
        v-model="tab"
        background-color="primary"
        dark
        next-icon="mdi-arrow-right-bold-box-outline"
        prev-icon="mdi-arrow-left-bold-box-outline"
        show-arrows
      >
        <v-tabs-slider color="white"></v-tabs-slider>
        <v-tab> Input Numbers </v-tab>
        <v-tab> Select From Contacts </v-tab>
        <v-tab> Select Contact Groups </v-tab>
        <v-tab> Import CSV </v-tab>
      </v-tabs>

      <v-tabs-items
        v-if="
          receivedTemplates &&
          receivedSenderIds &&
          receivedGroups &&
          receivedContacts
        "
        v-model="tab"
      >
        <v-tab-item>
          <InputNumber
            :templates="receivedTemplates.templates"
            :senderIds="receivedSenderIds.senderIds"
          />
        </v-tab-item>
        <v-tab-item>
          <SelectContact
            :templates="receivedTemplates.templates"
            :senderIds="receivedSenderIds.senderIds"
            :contacts="receivedContacts.contacts"
          />
        </v-tab-item>
        <v-tab-item>
          <SelectGroup
            :templates="receivedTemplates.templates"
            :senderIds="receivedSenderIds.senderIds"
            :groups="receivedGroups.groups"
          />
        </v-tab-item>
        <v-tab-item>
          <ExcelCSV
            :templates="receivedTemplates.templates"
            :senderIds="receivedSenderIds.senderIds"
          />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import InputNumber from "@/components/sms/send/InputNumber";
import SelectContact from "@/components/sms/send/SelectContact";
import SelectGroup from "@/components/sms/send/SelectGroup";
import ExcelCSV from "@/components/sms/send/ExcelCSV";
export default {
  components: { InputNumber, SelectContact, SelectGroup, ExcelCSV },
  data() {
    return {
      tab: null,
    };
  },
  created() {
    this.$store.dispatch("templates/fetchTemplates", 1);
    this.$store.dispatch("senderids/fetchSenderIds", 1);
    this.$store.dispatch("contacts/fetchContactsBulk", 1);
    this.$store.dispatch("groups/fetchGroupsBulk", 1);
  },
  computed: {
    receivedTemplates() {
      return this.$store.getters["templates/templates"];
    },
    receivedSenderIds() {
      return this.$store.getters["senderids/senderIds"];
    },
    receivedContacts() {
      return this.$store.getters["contacts/contacts"];
    },
    receivedGroups() {
      return this.$store.getters["groups/groups"];
    },
  },
};
</script>

<style scoped>
.v-tab {
  text-transform: none;
}
</style>
